export enum OfficeLocationSidebarViewEnum {
  PROFIL = 'Praxisdaten',
  PERSONALIZATION = 'Anpassungen',
  RESSOURCES = 'Ressourcen',
  SUBSCRIPTION_MANAGEMENT = 'Abonnement',
  PRICE_LISTS = 'Preislisten',
}
